module.exports = __webpack_public_path__ + "static/media/close_red.561ce26c.svg";